import {
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Stack } from '@superdispatch/ui';
import { AnchorButton, Button } from '@superdispatch/ui-lab';
import { useState } from 'react';

interface LoadsImportErrorDialogProps {
  onClose: () => void;
  files: File[];
  errorMessage?: string;
}

export function LoadsImportErrorDialog({
  onClose,
  files,
  errorMessage,
}: LoadsImportErrorDialogProps) {
  return (
    <Dialog open={!!errorMessage} onClose={onClose}>
      <LoadsImportErrorDialogContent
        onClose={onClose}
        files={files}
        errorMessage={errorMessage}
      />
    </Dialog>
  );
}

interface LoadsImportErrorDialogContentProps {
  files: File[];
  onClose: () => void;
  errorMessage?: string;
}

function LoadsImportErrorDialogContent({
  onClose,
  files,
  errorMessage,
}: LoadsImportErrorDialogContentProps) {
  const [isErrorDetailsVisible, setIsErrorDetailsVisible] = useState<boolean>();

  return (
    <>
      <DialogTitle>
        {files[0]?.type === 'application/pdf'
          ? 'We couldn’t import this dispatch sheet'
          : 'We couldn’t import this load'}
      </DialogTitle>
      <DialogContent>
        <Stack space="small">
          <Typography>
            {files[0]?.type === 'application/pdf' ? (
              <>
                The dispatch sheet you are importing is not supported yet. You
                can find the list of supported brokers in the help article.
              </>
            ) : (
              <>
                The CSV file you are trying to import differs from our template.{' '}
                <Link
                  download={true}
                  href="https://storage.googleapis.com/superdispatch-carrier-tms-production/templates/CSV-import-template.csv"
                  color="primary"
                >
                  Download a sample CSV template
                </Link>{' '}
                to see an example of the format required. Also, check the help
                article to see CSV import requirements.
              </>
            )}
          </Typography>
          <Stack space="xsmall">
            <Button
              variant="text"
              endIcon={isErrorDetailsVisible ? <ExpandLess /> : <ExpandMore />}
              onClick={() => {
                setIsErrorDetailsVisible(!isErrorDetailsVisible);
              }}
            >
              More Details
            </Button>
            <Collapse in={isErrorDetailsVisible}>{errorMessage}</Collapse>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions>
        <AnchorButton
          variant="neutral"
          target="_blank"
          href="https://support.superdispatch.com/hc/articles/35622600792339-Import-PDF-Dispatch-Sheets-CSV-Loads"
        >
          Open Help Article
        </AnchorButton>
        <Button onClick={onClose}>Got It</Button>
      </DialogActions>
    </>
  );
}
